/**
 * @fileoverview Method Prep Prep utils
 */
import { getRelevantNavItems } from 'components/Common/LayoutV2/utils';
import { API } from 'config_app';

export const loginURL = `${API}/api/v1/mtp/login/`;

export const displayLoginButton = user => {
  const { layout = {}, type = [] } = user;
  const sideNav = getRelevantNavItems(layout, type, 'sideNav');

  return sideNav?.[0]?.items
    ?.find(({ key }) => key === 'side-menu-college')
    ?.menuOptions.find(({ key }) => key === 'side-method-test-prep-login')
    ?.isEnabled;
};
